module.exports = __webpack_public_path__ + "static/img/m_article_andriod@3x.0c8888e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/m_article_andriod@3x.png
// module id = XHCq
// module chunks = 1